<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" fill="none" viewBox="0 0 16 21">
    <path fill="#fff" d="M6.857 15.935V1.064c0-.282.12-.553.335-.752C7.406.112 7.697 0 8 0c.303 0 .594.112.808.312.214.2.335.47.335.752v14.871L8 17l-1.143-1.064zm1.951 4.325l6.857-6.385c.215-.199.335-.47.335-.752 0-.282-.12-.553-.335-.752-.214-.2-.505-.312-.808-.312-.303 0-.594.112-.808.312L8 18.003 1.951 12.37c-.214-.2-.505-.312-.808-.312-.303 0-.594.112-.808.312-.215.2-.335.47-.335.752 0 .282.12.553.335.753l6.857 6.384c.106.099.232.177.37.23.14.054.288.081.438.081.15 0 .299-.027.437-.08.139-.054.265-.132.371-.231z"/>
  </svg>
</template>

<script>
  export default {
    name: "UnderArrow"
  }
</script>

<style scoped>

</style>